import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Grid = styled(({ ...props }) => <BaseGrid {...props} />)``
